import React, {useState, useEffect} from 'react';
import Crossing from './Crossing';

const Trip = props => {
    const [crossingId, setCrossingId] = useState(0);
    const [crossingResetId, setCrossingResetId] = useState(0);

    useEffect(() => {
        if (props.scoring.currentTrip < 0) {
            // if a trip is accessed from the QA menu, the user technically didn't choose a route.
            // here we arbitrarily pick a route (from the current trip) to keep things chugging along
            const placeholderRouteId = ['west', 'southwest', 'midwest'][props.data.tripId];
            props.scoring.initializeTrip(placeholderRouteId, props.data.tripId);
        }
    }, [])
    
    const incrementCrossingId = () => {
        if (crossingId === props.data.crossings.length-1) {
            props.onComplete()
        } else {
            let newId = crossingId+1;
            setCrossingId(newId);
        }
    }

    const resetCrossing = () => {
        setCrossingResetId(crossingResetId+1);
    }

    const revisitOrientation = () => {
        props.setModuleIndex(1);
    }

    return (
        <div className={`Trip ${props.data.class || ''}`}>
            <Crossing {...props} key={`crossing-${crossingId}-reset-${crossingResetId}`} resetCrossing={resetCrossing} scoring={props.scoring} setScoring={props.setScoring} data={props.data.crossings[crossingId]} tripId={props.data.tripId} crossingId={crossingId} crossingComplete={incrementCrossingId} revisitOrientation={revisitOrientation} />
        </div>
    )
};

export default Trip